import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const AMBASSADOR_1_IMAGE = "https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/n505f4cs_hele.png";
const AMBASSADOR_2_IMAGE = "https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/f7c85igj_teno.png";

const ambassadors = [
  {
    id: "helena",
    name: "Abg. M. Helena",
    lastName: "Lopez",
    role: "HIGH POTENCIAL",
    subtitle: "EXPERIENC3",
    image: AMBASSADOR_1_IMAGE,
  },
  {
    id: "franklin",
    name: "Franklin",
    lastName: "Tenorio",
    role: "NUESTRO REFERENTE",
    subtitle: "",
    image: AMBASSADOR_2_IMAGE,
  },
];

export default function AmbassadorsSection() {
  return (
    <section data-testid="ambassadors-section" className="px-4 sm:px-6 pb-16 max-w-7xl mx-auto -mt-9">
      <div className="flex flex-col items-center space-y-4">
        {ambassadors.map((amb, i) => (
          <motion.div
            key={amb.id}
            data-testid={`ambassador-${amb.id}`}
            initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: i * 0.15 }}
            viewport={{ once: true }}
            className="ambassador-card rounded-full border border-white overflow-hidden flex items-center gap-4 px-4 sm:px-6"
            style={{ width: '300px', height: '90px', backgroundColor: 'rgba(229, 229, 229, 0.95)' }}
          >
            {/* Avatar */}
            <div className="w-16 h-16 sm:w-18 sm:h-18 rounded-full overflow-hidden flex-shrink-0 border-2 border-[#C4A15E]/20">
              <img
                src={amb.image}
                alt={`${amb.name} ${amb.lastName}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              {amb.id === "helena" ? (
                <div className="flex flex-col items-end">
                  <p className="font-body text-sm sm:text-base text-[#0F0F10] whitespace-nowrap">
                    Abg. M. helena <span className="font-heading font-bold text-base sm:text-lg">Lopez</span>
                  </p>
                  <img
                    src="https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/dqofc7co_hip.png"
                    alt="High Potencial Experience"
                    className="h-9 sm:h-10 w-auto object-contain mt-1"
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="flex flex-col items-end flex-1">
                  <p className="font-body text-sm sm:text-base text-[#0F0F10]">
                    {amb.name} <span className="font-heading font-bold text-base sm:text-lg">{amb.lastName}</span>
                  </p>
                  <p className="font-body text-[10px] sm:text-xs font-normal text-[#6B7280] mt-0.5">
                    Nuestro Referente
                  </p>
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
